<div class="full-height flex center-both"><div class="flex column"><h1>An error occurred</h1><p>Please try reloading the page</p></div></div>